import request from "@/api";
import { BaseService } from "@/api/services/baseService";
import type { InvoiceForm, Page, Invoice, InvoiceQueryParams, InvoiceVo, InvoiceCountVo } from "@zhihaoscm/entity";
import { confirmable } from "@/utils/decorator/confirmable";
export class invoiceService extends BaseService<unknown, unknown, unknown, unknown> {
    public async paging(params: InvoiceQueryParams): Promise<Page<Invoice>> {
        const { data } = await this.service.get(`${this.path}/paging`, { params });
        return data;
    }
    //开票详情
    public async findById(id: string): Promise<InvoiceVo> {
        const { data } = await this.service.get(`${this.path}/vo/${id}`);
        return data;
    }
    //作废
    public async invalid(id: string, params: { reasons: string; fileId?: string }): Promise<Invoice> {
        const { data } = await this.service.put(`${this.path}/invalid/${id}`, undefined, {
            params: {
                ...params
            }
        });
        return data;
    }
    //已开票总金额
    public async totalCount(params: { productId?: string; productType?: number }): Promise<InvoiceCountVo> {
        const { data } = await this.service.get(`${this.path}/calc-total-count`, { params });
        return data;
    }
    // 新增发票
    @confirmable("是否提交")
    public async addInvoice(params: InvoiceForm): Promise<Invoice> {
        const { data } = await this.service.post(`${this.path}`, params);
        return data;
    }
}
export const tradeInvoiceService = new invoiceService("/admin/invoice", request.service);
